import { applyMiddleware, createStore, Store } from 'redux'
import reduxThunk from 'redux-thunk'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import reducers from '@App/reducers'

const persistConfig = {
  storage,
  key: 'root',
}

const persistedReducer = persistReducer(persistConfig, reducers)

export const store: Store<any> = createStore(
  persistedReducer,
  applyMiddleware(reduxThunk),
)

export const persistor = persistStore(store)
